export { default as MiniLegend } from './MiniLegend';
export * from './MiniLegend';